import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PrestadorServico } from 'src/app/models/rh/prestador-servico.model';
import { URL_GLOBAL, URL_WEB } from 'src/environments/environment';
import { CacheService } from '../cache/cache.service';
import { AuthService } from '../vos/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PrestadorServicoService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private cacheService: CacheService
  ) {}

  GetPrestadoresServicos(): Observable<PrestadorServico[]> {
    return this.http.get<PrestadorServico[]>(`${URL_GLOBAL}/prestadores`);
  }

  save(data: any): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/prestadores`, data, {
      headers: this.authService.userToken(),
    });
  }
  _find(param: any, id: any): Observable<any> {
    return this.http.get(`${URL_GLOBAL}/prestadores/${id}`, {
      params: new HttpParams().append('commands', JSON.stringify(param)),
    });
  }
  update(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${`${URL_GLOBAL}/prestadores`}/${id}`, data);
  }
  historicopacientesprestador(id: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${`${URL_WEB}/areaClinica/profissionais/historicopacientesprestador`}/${id}?d`,
      { headers: this.authService.userToken() }
    );
  }
  buscaPrestadores(type?: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/prestadores/listNomePrestadores${
        type ? `?type=${type}` : ''
      }`,
      { headers: this.authService.userToken() }
    );
  }

  buscaPrestadoresFinanceiro(): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/prestadores/listNomePrestadoresFinanceiro`,
      { headers: this.authService.userToken() }
    );
  }
  buscaPrestadoresComFiltro(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/prestadores/listaComFiltro?nome=${param.nome}&formacao=${param.formacao}&cidade=${param.cidade}`,
      { headers: this.authService.userToken() }
    );
  }
  buscaprofissionaisPorFiltro(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/prestadores/atribuicao?nome=${param.nome}&cpf=${param.cpf}&conselho=${param.conselho}`,
      { headers: this.authService.userToken() }
    );
  }
  buscaprofissionaisPorFiltro2(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/prestadores/atribuicao2?nome=${param.nome}&cpf=${param.cpf}&conselho=${param.conselho}`,
      { headers: this.authService.userToken() }
    );
  }
  buscaprestadoresrecrutadoPorFiltro(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/prestadores/atribuicaofixa?nome=${param.nome}&cpf=${param.cpf}&conselho=${param.conselho}`,
      { headers: this.authService.userToken() }
    );
  }
  dashboardProfissionaisExternos(): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/recursosHumanos/dashboard/dashboardProfissionaisExternos`,
      { headers: this.authService.userToken() }
    );
  }
  buscalistadeconselhospodidpessoa(pessoa_id): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/departamentoPessoal/buscalistadeconselhospodidpessoa/${pessoa_id}`,
      { headers: this.authService.userToken() }
    );
  }
  salvarconselho(conselho): Observable<any[]> {
    return this.http.post<any[]>(
      `${URL_GLOBAL}/web/departamentoPessoal/salvarconselho`,
      conselho,
      { headers: this.authService.userToken() }
    );
  }
  // salvartelefone(telefone): Observable<any[]> {
  //   return this.http.post<any[]>(`${URL_GLOBAL}/web/departamentoPessoal/salvartelefone`, telefone, { headers: this.authService.userToken() });
  // }
  salvartelefone(telefone, pessoa_id): Observable<any[]> {
    return this.http.post<any[]>(
      `${URL_GLOBAL}/web/pessoas/${pessoa_id}/adicionarTelefone`,
      telefone,
      { headers: this.authService.userToken() }
    );
  }
  deletarconselho(conselho_id): Observable<any[]> {
    return this.http.delete<any[]>(
      `${URL_GLOBAL}/web/departamentoPessoal/deletarconselho/${conselho_id}`,
      { headers: this.authService.userToken() }
    );
  }
  buscaprestadorexterno(id): Observable<any> {
    return this.http.get<any>(
      `${URL_GLOBAL}/web/prestadores/buscaprestadorexterno/${id}`,
      { headers: this.authService.userToken() }
    );
  }
  buscalistadebancospodidpessoa(pessoa_id): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/departamentoPessoal/buscalistadebancospodidpessoa/${pessoa_id}`,
      { headers: this.authService.userToken() }
    );
  }
  buscalistadetelefonespodidpessoa(pessoa_id): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/departamentoPessoal/buscalistadetelefonespodidpessoa/${pessoa_id}`,
      { headers: this.authService.userToken() }
    );
  }
  salvarbanco(banco): Observable<any[]> {
    return this.http.post<any[]>(
      `${URL_GLOBAL}/web/departamentoPessoal/salvarbanco`,
      banco,
      { headers: this.authService.userToken() }
    );
  }
  deletarbanco(banco_id): Observable<any[]> {
    return this.http.delete<any[]>(
      `${URL_GLOBAL}/web/departamentoPessoal/deletarbanco/${banco_id}`,
      { headers: this.authService.userToken() }
    );
  }
  deletartelefone(telefone_id): Observable<any[]> {
    return this.http.delete<any[]>(
      `${URL_GLOBAL}/web/departamentoPessoal/deletartelefone/${telefone_id}`,
      { headers: this.authService.userToken() }
    );
  }
  deletarendereco(endereco_id): Observable<any[]> {
    return this.http.delete<any[]>(
      `${URL_GLOBAL}/web/departamentoPessoal/deletarendereco/${endereco_id}`,
      { headers: this.authService.userToken() }
    );
  }
  salvarendereco(endereco): Observable<any[]> {
    return this.http.post<any[]>(
      `${URL_GLOBAL}/web/departamentoPessoal/salvarendereco`,
      endereco,
      { headers: this.authService.userToken() }
    );
  }
  buscalistadeenderecospodidpessoa(pessoa_id): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/departamentoPessoal/buscalistadeenderecospodidpessoa/${pessoa_id}`,
      { headers: this.authService.userToken() }
    );
  }
  buscaprestadorporcliente(params): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/prestadores/buscaPrestadoresPorCliente?cliente_id=${
        params.cliente_id ? params.cliente_id : ''
      }&data_ini=${params.dataInicio}&data_fim=${
        params.dataFim
      }&type_contract=${params.type_contract ? params.type_contract : ''}`,
      { headers: this.authService.userToken() }
    );
  }
  //NEW END POINTS
  getProvidersClients(params): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_GLOBAL}/web/reports/list-providers-clients?cliente_id=${
        params.cliente_id ? params.cliente_id : ''
      }&data_ini=${params.dataInicio}&data_fim=${
        params.dataFim
      }&type_contract=${params.type_contract ? params.type_contract : ''}`,
      { headers: this.authService.userToken() }
    );
  }

  getProvidersOfAssignment(param: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${URL_WEB}/scale/providers-assignment?nome=${param.nome}&cpf=${param.cpf}&conselho=${param.conselho}`,
      { headers: this.authService.userToken() }
    );
  }

  getProfessionalData({ professional_id, start_date, end_date }) {
    return this.cacheService.callHttpRequestWithCache({
      url: `${URL_WEB}/prestadores/dashboard?professional_id=${professional_id}&start_date=${start_date}&end_date=${end_date}`,
      isAuthenticated: true,
      timeInMinutes: 30,
    });
  }
}
